import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fw-bold mb-4 mt-4" }
const _hoisted_2 = { class: "d-flex align-items-center mb-3" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "fs_24 fw_700",
  style: {"margin-top":"-7px","display":"block"}
}, "+", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "list-group" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "fs_24 fw_700",
  style: {"margin-top":"-7px","display":"block"}
}, "-", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "d-flex justify-content-end mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.localValue.garmentConfigurationLayerName), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_form_field, {
        type: "text",
        labelKey: "Add property",
        labelValue: "Add property",
        placeholderKey: "Add property",
        placeholderValue: "Add property",
        modelValue: _ctx.newProperty,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newProperty) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("button", {
        class: "btn btn-primary ms-2",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addProperty())),
        disabled: !_ctx.newProperty
      }, _hoisted_5, 8, _hoisted_3)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue.properties, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "list-group-item d-flex justify-content-between align-items-center",
            key: index
          }, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(item), 1),
            _createElementVNode("button", {
              class: "btn btn-primary ms-2",
              onClick: ($event: any) => (_ctx.removeProperty(item))
            }, _hoisted_10, 8, _hoisted_8)
          ]))
        }), 128))
      ]),
      (_ctx.isLast)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn btn-secondary me-2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('prev')))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Previous",
                text: "Previous"
              })
            ]),
            _createElementVNode("button", {
              class: "btn btn-tertiary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('next')))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Continue",
                text: "Continue"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}